export const COMPANY_TOOLBAR_TITLE = "Company";
export const CREATE_COMPANY_TITLE = "Add a Company";
export const BACK_TO_MENU_TITLE = "Back to Menu";

export const DUPLICATE_ERROR = "Duplicate company name";

export const DEFAULT_ROWS_PER_PAGE = 50;

export const MANAGE_COMPANY_TABLE_HEAD_CELLS = [
    { id: 'name', center: true, disablePadding: false, label: 'Name' },
    { id: 'enabled', center: true, disablePadding: false, label: 'Enabled' },
]

export const MANAGE_FOLDER_TABLE_HEAD_CELLS = [
   { id: '', center: true, disablePadding: false, label: '' },
    { id: '', center: false, disablePadding: false, label: 'Title' },
    { id: '', center: true, disablePadding: false, label: 'Image' },
    { id: '', center: true, disablePadding: false, label: '' }
]

export const EDIT = "Edit"

export const ROWS_PER_PAGE_LABEL = "Results"
export const DEFAULT_SORT_BY_HEAD_CELL = "name"

export const ENABLE_COMPANY_CHECKBOX_LABEL = "Enable Company"


export function getDisplayLabel(label) {
    const mapping = {
        'Manage Users': 'Manage Employees',
        'Report': 'Weekly Report',
        'Machine Picture': 'Machine Reading Pictures',
        'Add Machine Reading': 'Start New Reading Session',
        'Master Reading': 'Reading Sessions Record',
    };

    return mapping[label] || label;
}